import {toastAlert} from "../toastAlert";
import {EpMap} from "../map/map";
import { transform } from 'ol/proj';
import * as $ from "jquery";
import {confirmModal} from "../confirmModal";
import {disableButtons, enableFormBack} from "../forms";
import {createFeatureFromCoordinates} from "../map/utilities";
import axios from "axios";
import {url} from "../utilities";
import Spinner from "../spinner";

export const zipod_page = () => {

    let sectors = JSON.parse(window._sectors ?? '[]');
    let devices = JSON.parse(window._devices ?? '[]');


    let mapContainer = $("#mapContainer");
    let latitudeField = $('#addZipodReport_latitude');
    let longitudeField = $('#addZipodReport_longitude');
    if (mapContainer.length > 0) {
        let epMap = new EpMap({target: 'mapContainer', hideLabelsIfNecessary: true});
        let map = epMap.getOlMap();
        let pointerEpLayer = epMap.addPointerLayer();
        let pointerSource = pointerEpLayer.getSource();

        let sectorsLayer = epMap.addSectorsLayer().getLayer();
        let sectorsSource = sectorsLayer.getSource();

        let boundariesLayer = epMap.addBoundariesLayer().getLayer();
        let boundariesSource = boundariesLayer.getSource();

        let devicesLayer = epMap.addDevicesLayer().getLayer();
        let devicesSource = devicesLayer.getSource();

        if(window._boundaries) {
            let feature = createFeatureFromCoordinates(window._boundaries, 'boundaries');
            boundariesSource.addFeature(feature);
        }

        if(sectors.length > 0) {
            epMap.sectors.addSectorsFromObject(sectors);
        }

        if(devices.length > 0){
            epMap.devices.addDevicesFromObject(devices);
        }

        epMap.hideLabelsIfNecessary(epMap.getEpLayerByName('devices'));
        epMap.hideLabelsIfNecessary(epMap.getEpLayerByName('sectors'));


        map.on('click', function(evt){
            let lonlat = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326');
            longitudeField.val(lonlat[0].toPrecision(8));
            latitudeField.val(lonlat[1].toPrecision(8));

            let features = pointerSource.getFeatures();
            if(features.length > 0) {
                pointerSource.removeFeature(features[0]);
            }
            pointerEpLayer.addToMapFromCoordinates(lonlat[0] + ',' + lonlat[1]);
        });

        $('.btnGetLocalization').click(function(){

            let geo = navigator.geolocation;

            if(geo) {
                geo.getCurrentPosition(function(location) {
                    latitudeField.val(location.coords.latitude.toPrecision(8));
                    longitudeField.val(location.coords.longitude.toPrecision(8));
                    let features = pointerSource.getFeatures();
                    if(features.length > 0) {
                        pointerSource.removeFeature(features[0]);
                    }
                    pointerEpLayer.addToMapFromCoordinates(location.coords.longitude + ',' + location.coords.latitude);
                    map.getView().setCenter(transform([location.coords.longitude, location.coords.latitude], 'EPSG:4326', 'EPSG:3857'));
                    map.getView().setZoom(15);
                    toastAlert(`Pozycja została ustalona z dokładnością do ${Math.round(location.coords.accuracy)} m. <strong><u>Sprawdź poprawność danych na mapie.</u></strong>`, {type:"info"});
                });
            }
            else {
                toastAlert('Podczas pobierania lokalizacji wystąpił błąd. Spróbuj ponownie później.')
            }
        })

        $('#addZipodReport_latitude, #addZipodReport_longitude').change(function (){
            let features = pointerSource.getFeatures();
            if(features.length > 0) {
                pointerSource.removeFeature(features[0]);
            }
            try {
                pointerEpLayer.addToMapFromCoordinates(longitudeField.val() + ',' + latitudeField.val());
            }catch(e){
                toastAlert('Podczas ładowania danych wystąpił błąd. Spróbuj ponownie.', {type:"danger"});
            }
        }).change()

        $('#addZipodReport_shot_type').find('option[value="polowanie"]').attr('selected', 'selected')

        $('.btnGetAttachments').click(function(){
            let huntingAttachments = $('.huntingAttachments');
            huntingAttachments.show();
            $('input[name="load_attachments"]').val(1);
            $('.btnRemoveAttachments').show();
            $(this).hide();
            toastAlert('Pomyślnie załadowano zdjęcia z polowania');
        })

        $('.btnRemoveAttachments').click(function(){
            let huntingAttachments = $('.huntingAttachments');
            huntingAttachments.hide();
            $('input[name="load_attachments"]').val(0);
            $('.btnGetAttachments').show();
            $(this).hide();
            toastAlert('Pomyślnie cofnięto załadowane zdjęcia');
        })

    }

    $('#zipodNotSentTable').DataTable({
        stateSave: false,
        order: [1, 'desc'],
        filters: {
            columns: [
                {
                    index: 2,
                    title: 'Numer obwodu'
                }
            ]
        }
    })

    $('#zipodSentTable').DataTable({
        stateSave: false,
        order: [1, 'desc'],
        filters: {
            columns: [
                {
                    index: 2,
                    title: 'Numer obwodu'
                }
            ]
        }
    })

    $('#zipodNotSentDeathsTable').DataTable({
        stateSave: false,
        order: [0, 'desc'],
        filters: {
            columns: [
                {
                    index: 1,
                    title: 'Numer obwodu'
                }
            ]
        }
    })

    $('#zipodSentDeathsTable').DataTable({
        stateSave: false,
        order: [0, 'desc'],
        filters: {
            columns: [
                {
                    index: 1,
                    title: 'Numer obwodu'
                }
            ]
        }
    })

    $('#zipodSentCollectiveTable').DataTable({
        stateSave: false,
        order: [0, 'desc'],
        filters: {
            columns: [
                {
                    index: 1,
                    title: 'Numer obwodu'
                }
            ]
        }
    })

    $('#zipodNotSentCollectiveTable').DataTable({
        stateSave: false,
        order: [0, 'desc'],
        filters: {
            columns: [
                {
                    index: 1,
                    title: 'Numer obwodu'
                }
            ]
        }
    })

    $('.btnZipodChangeStatus').click(async function (){
        let that = $(this);
        let id = that.data('id');
        let type = that.data('type');

        let response = await axios.post(url(`api/zipod/change-status`), {
            id: id,
            type: type,
        });
        let data = response.data;
        if(parseInt(data.code) === 200){
            toastAlert('Pomyślnie zmieniono status zgłoszenia. Zgłosznie pojawi się w zakładce `Zgłoszone` po odświeżeniu strony.');
        }else {
            toastAlert('Podczas zmiany statusu zgłosznia wystąpił błąd. Spróbuj ponownie później.', {type: 'danger'});
        }
        that.remove();
    });

    $("#zipodXlsx").on('submit', function(e){
        e.preventDefault();
        let spinner = new Spinner();
        this.submit();
        spinner.destroy();
        enableFormBack();
    })

    let body = $('body');

    body.on('click', '.ddeButton' , async function (e){
        e.preventDefault();
        let id = $(this).data('district_id');
        let response = await axios.get(url(`app/zipod/${id}/veterinarian`));

        if(!response.data.veterinarian){
            let confirmed = await confirmModal('W ustawieniach wybranego obwodu pole "Powiatowy Lekarz Weterynarii" jest puste. Czy chcesz kontynuować? ', {color: 'warning'});
            if (!confirmed) {
                return;
            }else{
                open(this.href, '_blank');
            }
        }else{
            open(this.href, '_blank');
        }

    })



}
